module.exports = __webpack_public_path__ + "img/crown.8eb5b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/community/crown.png
// module id = nICP
// module chunks = 15